/**
 * Module-wide financial close helpers.
 */

import { CYCLE_STAGES } from './constants.js';

const EM_DASH = '\u2014';

const UTC_DATE_FORMAT = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
};

const UTC_TIME_FORMAT = {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};

/**
 * True when the cycle stage is Closed (3). Coerces numeric strings.
 * @param {number|string} stage
 * @returns {boolean}
 */
export function isCycleClosed(stage) {
  return Number(stage) === CYCLE_STAGES.CLOSED;
}

/**
 * Formats an ISO instant in the browser local timezone.
 * No `timeZone` option — Intl uses the runtime zone. The result has no zone name or offset.
 * @param {string} iso
 * @param {{ part?: 'date' | 'time' | 'datetime' }} [options]
 * @returns {string} Date, time, or both, or an em dash when empty or invalid.
 */
export function formatUtcDateTime(iso, { part = 'datetime' } = {}) {
  if (iso == null || String(iso).trim() === '') {
    return EM_DASH;
  }

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return EM_DASH;
  }

  const dateText = new Intl.DateTimeFormat(undefined, UTC_DATE_FORMAT).format(date);
  const timeText = new Intl.DateTimeFormat(undefined, UTC_TIME_FORMAT).format(date);

  if (part === 'date') return dateText;
  if (part === 'time') return timeText;
  return `${dateText} ${timeText}`;
}
